import Entity from '../entity'
export default class SubEstadoParticipacion extends Entity<number>{
    nombre: string;
    estadoParticipacionId: number;
    estadoParticipacionNombre: string
}